export default "__VITE_ASSET__aa0bf690__"